<div *ngIf="vm" class="container p-0">
  <p class="text-center" mat-dialog-title>Generator Search</p>
  
  <mat-dialog-content class="dialog-content-scrollable">
    <form *ngIf="vm.formGroup" [formGroup]="vm.formGroup">
      <p class="deploy-generator-header">Power Supply Details</p>
      <mat-form-field appearance="outline" class="mat-form-field-inline-class pt-1">
        <mat-label for="nodeSearchTerm">Find Node</mat-label>
        <input #nodeAutoTrigger="matAutocompleteTrigger"
               autocomplete="off"
               formControlName="nodeSearchTerm"
               id="nodeSearchTerm"
               matInput
               placeholder="Enter Node"
               [matAutocomplete]="nodeAuto">
        <mat-autocomplete #nodeAuto="matAutocomplete"
                          [displayWith]="getNodeName"
                          (optionSelected)="nodeSelected($event)">
            <mat-option *ngFor="let item of vm.nodeSearchResult; trackBy: trackByNode"
                        [value]="item">
            <span>{{ item.node }} / {{ item.nodeCmts }}</span>
            </mat-option>
        </mat-autocomplete>
        <button *ngIf="vm.isLoadingNodeData" class="search-icon spinner-button" matSuffix type="button">
            <mat-spinner diameter="25"></mat-spinner>
        </button>
        <button *ngIf="!vm.isLoadingNodeData"
                aria-label="Search for node"
                class="search-icon"
                mat-mini-fab
                matSuffix
                type="button"
                [disabled]="!vm.isNodeSearchButtonEnabled"
                (click)="searchNodeIcon()">
            <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="outline" class="mat-form-field-inline-class">
        <mat-label for="powerSupplyNameSearchTerm">Find Power Supply Name</mat-label>
        <input autocomplete="off"
               formControlName="powerSupplyNameSearchTerm"
               id="powerSupplyNameSearchTerm"
               matInput
               placeholder="Enter Power Supply Name"
               [matAutocomplete]="psNameAuto">
        <mat-autocomplete #psNameAuto="matAutocomplete"
                          [displayWith]="getPowerSupplyName"
                          (optionSelected)="searchByPowerSupplyName($event)">
            <mat-option *ngFor="let item of vm.powerSupplyNameSearchResult; trackBy: trackByPowerSupply"
                        [value]="item">
            <span>{{ item.powerSupplyName }}</span>
            </mat-option>
        </mat-autocomplete>
        <button class="search-icon" mat-mini-fab matSuffix type="button">
            <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="outline" class="mat-form-field-inline-class">
        <mat-label for="macSearchTerm">Find MAC Address</mat-label>
        <input autocomplete="off"
               formControlName="macSearchTerm"
               id="macSearchTerm"
               matInput
               max="17"
               maxlength="17"
               min="0"
               placeholder="Enter MAC Address"
               [matAutocomplete]="macAuto"
               (keydown.space)="$event.preventDefault()"
               (keypress)="omitSpecialChar($event)">
        <mat-autocomplete #macAuto="matAutocomplete"
                          [displayWith]="getMacAddress"
                          (optionSelected)="searchByMacAddress($event)">
            <mat-option *ngFor="let item of vm.macSearchResult; trackBy: trackByMac"
                        [value]="item">
            <span>{{ item.mac }}</span>
            </mat-option>
        </mat-autocomplete>
        <button *ngIf="vm.isLoadingMacData" class="search-icon spinner-button" matSuffix type="button">
            <mat-spinner diameter="25"></mat-spinner>
        </button>
        <button *ngIf="!vm.isLoadingMacData" class="search-icon" mat-mini-fab matSuffix type="button">
            <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>

    <div class="lat-long-offset mt-3">
      <mat-form-field appearance="outline" class="mat-form-field-inline-gps" hideRequiredMarker="true">
        <mat-label for="latitudeControl">Lat</mat-label>
        <input #latitude
               formControlName="latitudeControl"
               id="latitudeControl"
               matInput
               placeholder="Enter Latitude"
               (click)="getLocation()">
        <mat-error *ngIf="vm.formGroup.get('latitudeControl')?.errors">
          Latitude is <span class="required-text">required</span>
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="mat-form-field-inline-gps" hideRequiredMarker="true">
        <mat-label for="longitudeControl">Long</mat-label>
        <input #longitude
               formControlName="longitudeControl"
               id="longitudeControl"
               matInput
               placeholder="Enter Longitude">
        <mat-error *ngIf="vm.formGroup.get('longitudeControl')?.errors">
          Longitude is <span class="required-text">required</span>
        </mat-error>
      </mat-form-field>

      <button *ngIf="vm.isLoadingLocation" class="spinner-button" mat-mini-fab matSuffix type="button">
        <mat-spinner diameter="25"></mat-spinner>
      </button>
      <button *ngIf="!vm.isLoadingLocation"
              class="search-icon"
              mat-mini-fab
              matSuffix
              type="button"
              [disabled]="((!vm.formGroup.get('longitudeControl')?.valid) ||
                           (!vm.formGroup.get('latitudeControl')?.valid))"
              (click)="searchByLocation()">
        <mat-icon>search</mat-icon>
      </button>
    </div>

    <div *ngIf="vm.selectedPowerSupplyName" class="selected-ps-info">
      <p><span class="required-text">Selected Power Supply:</span> {{ vm.selectedPowerSupplyName }}</p>
    </div>
    <div *ngIf="vm.noPowerSupplyFound" class="ps-avl selected-ps-info">
      <p><span class="required-text">No Power Supply Available</span></p>
    </div>
    <div class="space-adjust"></div>

    <p class="deploy-generator-header">Generator</p>
    <mat-form-field appearance="outline" class="mat-form-field-inline-class pt-1">
      <mat-label for="generatorAssetID">Asset ID</mat-label>
      <input id="generatorAssetID"
             matInput
             readonly
             [value]="getGeneratorIdentifier()">
    </mat-form-field>

    <mat-form-field appearance="outline" class="mat-form-field-inline-class">
      <mat-label for="generatorSerialNumber">Serial Number</mat-label>
      <input id="generatorSerialNumber"
             matInput
             readonly
             [value]="vm.generatorSerialNumber || ''">
    </mat-form-field>
    <div class="space-adjust"></div>

    <p class="deploy-generator-header">Extended Runtime Fuel Tank</p>
    <mat-form-field appearance="outline" class="mat-form-field-inline-class pt-1">
      <mat-label for="fuelTankIDSearchTerm">Asset ID</mat-label>
      <input #fuelTankIDAutoTrigger="matAutocompleteTrigger"
             formControlName="fuelTankIDSearchTerm"
             id="fuelTankIDSearchTerm"
             matInput
             placeholder="QR Code Asset Id - Fuel Tank"
             [matAutocomplete]="fuelTankIDAuto">
      <mat-autocomplete #fuelTankIDAuto="matAutocomplete"
                        [displayWith]="getAssetID"
                        (optionSelected)="searchByFuelTankId($event)">
        <mat-option *ngFor="let asset of vm.fuelTankAssetSearchResult; trackBy: trackByFuelTank"
                    [value]="asset">
          <span>
            <span *ngIf="asset.assetId">{{ asset.assetId }} | </span>
            <span *ngIf="asset.localId">{{ asset.localId }} | </span>
            <span *ngIf="asset.fuelTankId">{{ asset.fuelTankId }}</span>
          </span>
        </mat-option>
      </mat-autocomplete>
      <button aria-label="Open QR scanner"
              class="search-icon"
              mat-mini-fab
              matSuffix
              type="button"
              (click)="openFuelTankScanner()">
        <mat-icon>qr_code_scanner</mat-icon>
      </button>
    </mat-form-field>
    <div class="space-adjust"></div>

      <p class="deploy-generator-header">Comments</p>
      <mat-form-field appearance="outline" class="mat-form-field-inline-class pt-1">
        <mat-label for="comments">Comments</mat-label>
        <input formControlName="comments"
               id="comments"
               matInput
               placeholder="Comments">
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions-fixed">
    <div class="d-flex justify-content-center mt-3">
        <button class="cancel-button-color dialog-action-button"
                mat-raised-button
                type="button"
                [mat-dialog-close]="false">
          Close
        </button>
        <button class="confirm-button-color dialog-action-button"
                color="primary"
                mat-raised-button
                [disabled]="vm.deployGeneratorButtonDisabled"
                (click)="deployGenerator()">
          Deploy
        </button>
    </div>
  </mat-dialog-actions>
</div>
